
import { useState, useEffect, useRef } from "react";
import { useLocation } from 'react-router-dom';

import { useQuery } from "@tanstack/react-query";

import { IconButton, Button } from "@mui/material";
import TuneIcon from '@mui/icons-material/Tune';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical, faFileExcel} from '@fortawesome/free-solid-svg-icons';



import { SearchOutlined } from '@ant-design/icons';
import { FilterFilled } from '@ant-design/icons';



import { Dropdown, Menu, Form, Space, DatePicker } from 'antd';



// import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

import authAxios from "../components/authAxios";

import moment from 'moment';



// import Layout from "../components/Layout";
import DashboardHeader from "../components/DashboardHeader";
// import './EndMonthReport.css'
import './ReceiptRegister.css';

import { width } from "@fortawesome/free-brands-svg-icons/fa42Group";

import Loading from "../components/Loading";


const ReceiptRegister = () => {
    const location = useLocation();
    const { RangePicker } = DatePicker;

    // const [reportMonth, setReportMonth] = useState(moment().format('MM'))
    // const [reportYear, setReportYear] = useState(moment().format('YYYY'))
    // const [startDate, setStartDate] = useState(null);
    // const [endDate, setEndDate] = useState(null);
    const [startDate, setStartDate] = useState(moment().startOf('month')); // default to start of current month
    const [endDate, setEndDate] = useState(moment());

    // const { data: expenseSchedule, isLoading } = useQuery({
    //     queryKey: ['expense-schedule', reportMonth, reportYear],
    //     queryFn: async () => {
    //         const response = await authAxios.get(`/accounting/expense-schedule/?year=${reportYear}`);
    //         return response.data
    //     },
    // });

    const { data: receiptRegister, isLoading } = useQuery({
        queryKey: ['receipt-register', startDate, endDate],
        queryFn: async () => {
            const response = await authAxios.get(`/accounting/receipt-register/?start_date=${startDate ? startDate.format('YYYY-MM-DD'): ''}&end_date=${endDate ? endDate.format('YYYY-MM-DD') : ''}`);
            return response.data
        },
    });


    if (isLoading) return <Loading loading={true} />;
    // const { headers = [], rows = [], totals } = expenseSchedule;

    const downloadXLS = () => {

        // const worksheetData = expenseSchedule.report_data.map(data => ({
        const worksheetData = receiptRegister.map(data => ({

            'No': data.id,
            'Property': data.name,
            'Rent Payable': parseFloat(data.rent_payable),
            'Royalty BF': parseFloat(data.royalty_bf),
            'Collectable B/F': parseFloat(data.collectable_bf),
            'Rent Paid': parseFloat(data.rent_paid),
            'Royalty Due': parseFloat(data.royalty_due),
            'Royalty Disbursed': parseFloat(data.owner_payments),
            'Commission': parseFloat(data.commission),
            'Royalty C/F': parseFloat(data.royalty_cf),
            'Collectable C/F': parseFloat(data.collectable_cf),
            'Total Income': parseFloat(data.total_income),
        })); 

        // Add the totals row at the end
        const totalsRow = {
            // 'No': '', // Label for the totals row
            // 'Property': 'TOTALS', // Leave empty for non-numeric columns
            // 'Rent Payable': parseFloat(expenseSchedule.totals.rent_payable),
            // 'Royalty BF': parseFloat(expenseSchedule.totals.royalty_bf),
            // 'Collectable B/F': parseFloat(expenseSchedule.totals.collectable_bf),
            // 'Rent Paid': parseFloat(expenseSchedule.totals.rent_paid),
            // 'Royalty Due': parseFloat(expenseSchedule.totals.royalty_due),
            // 'Royalty Disbursed': parseFloat(expenseSchedule.totals.owner_payments),
            // 'Commission': parseFloat(expenseSchedule.totals.commission),
            // 'Royalty C/F': parseFloat(expenseSchedule.totals.royalty_cf),
            // 'Collectable C/F': parseFloat(expenseSchedule.totals.collectable_cf),
            // 'Total Income': parseFloat(expenseSchedule.totals.total_income),
        };

        // Push the totals row to the worksheet data
        worksheetData.push(totalsRow);

        // Convert data to worksheet
        const ws = XLSX.utils.json_to_sheet(worksheetData);

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'End Month Report');

        // XLSX.writeFile(wb, `End_Month_Report_${reportMonth}_${reportYear}.xlsx`);
    };

    // const onChange = (date, dateString) => {
    //     setReportYear(date.year())
    //   };

    const onChange = (dates) => {
        if (dates && dates.length === 2) {
            setStartDate(dates[0]);
            setEndDate(dates[1]);
        }
    };

    const menu = (
        <Menu>
            <form className="filter-form">
                <Space direction="vertical">
                    {/* <DatePicker onChange={onChange} picker="year" placement="bottomRight" /> */}
                    {/* <DatePicker 
                        style={{margin:'10px'}}  
                        onChange={onChange} 
                        picker="date" 
                        placement="bottomRight" 
                    />  */}
                    <RangePicker 
                        style={{margin:'10px'}}  
                        onChange={onChange} 
                        placement="bottomRight" 
                    /> 
                </Space>
            </form>
        </Menu>
      );
    // const reportPreTitle="PERIOD "+reportMonth+"/"+reportYear
    const reportPreTitle="PERIOD "+(startDate ? startDate.format('DD-MM-YYYY') : '...')+" to "+(endDate ? endDate.format('DD-MM-YYYY') : '...');



    // a helper function to check if a column has data
    // const hasColumnData = (columnName) => {
    //     return expenseSchedule.report_data.some(row => row[columnName] !== 0 && row[columnName] !== null && row[columnName] !== undefined);
    //   };

    const formatNumber = (number) => {
        return number.toLocaleString('en-UK', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }


    return (
        // <div className="dashboard-main end-month-report expense-schedule">
        <div className="dashboard-main receipt-register">
            <section className="dashboard-content">
                <div className="dashboard-content-header-nav">
                    <DashboardHeader dashboardTitle="Receipt Register" dashboardPreTitle={reportPreTitle} />
                    <div className="dashboard-content-header-nav-icons">
                        {/* <IconButton onClick={downloadXLS}>
                            <FontAwesomeIcon className="menu-icon" icon={faFileExcel} />
                        </IconButton> */}
                        <Dropdown overlay={menu} trigger={['click']} placement="bottomRight" arrow>
                      
                        <Button className="menu-button-filter" variant="outlined" startIcon={<TuneIcon />}>
                            Filter
                        </Button>

                    </Dropdown>
                    </div>
                
                </div>
                <div className="table-container">


                <table >
                        <thead>
                            <tr>
                                <th>RECEIPT NO</th>
                                <th>DATE</th>
                                <th>CUSTOMER</th>
                                <th>REFERENCE</th>
                                <th>DESCRIPTION</th>
                                <th>AMOUNT</th>

                                {/* {headers.map(data => (
                                    <th key={data}>{data.toUpperCase()}</th>
                                ))} */}
                            </tr>
                        </thead>
                          
                        <tbody >
                            {/* {rows.map((data, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                {headers.map(hdr => (
                                    <td key={hdr}>{data[hdr].toLocaleString()}</td>
                                ))}
                            </tr>
                            ))} */}
                                {/* <tbody > */}
                            {receiptRegister && receiptRegister.rows.map(data => (
                            <tr key={data.id}>
                                <td>{data.reference}</td>
                                <td>{moment(data.date).format("DD-MM-YYYY")}</td>
                                <td>{data.customer}</td>
                                <td>{data.doc_ref}</td>
                                <td>{data.description}</td>
                                <td>{formatNumber(Number(data.amount))}</td>
                            </tr>       
                            ))}

                        </tbody>
                        {receiptRegister.totals && (
                            <tfoot>
                                <tr>
                                    {/* <td></td> */}
                                    <td colSpan="5">TOTALS</td>
                                    <td>{formatNumber(receiptRegister.totals)}</td>

                                    {/* {headers.map(hdr => (
                                        <td key={hdr}>
                                            {hdr === "account"
                                                ? "TOTALS"
                                                : totals[hdr].toLocaleString()
                                            }
                                        </td>
                                    ))} */}
                                </tr>
                            </tfoot>
                        )}


                </table>

                </div>



            </section>
        </div>
    );
};

export default ReceiptRegister;


